import { Request as OldRequestDT } from 'utils/customTypes';

export const serializeUpdateRequestParams = (
  request: OldRequestDT,
  isArchiving = false
) => {
  if (isArchiving) {
    return {
      isArchived: request.isArchived,
    };
  }
  const businessTeamId = request.businessTeams?.[0]?.id ?? null;
  const cost =
    !request.cost && request.cost !== '0'
      ? null
      : Number(request.cost.replace(/,/g, ''));
  const effort =
    !request.effort && request.effort !== '0' ? null : Number(request.effort);

  return {
    businessTeamId: businessTeamId,
    cost,
    data: request.data ?? {},
    description: request.description ?? '',
    effort,
    ldPriority: request.ldPriority,
    requesterId: request.requester_id,
    status: request.status,
    title: request.title,
  };
};
